import cssClasses from "./AddModal.module.css";
import Modal from "@mui/material/Modal";
import CloseIcon from "@mui/icons-material/Close";

function AddModal(props) {
  // console.log(props.footer);
  if (props.footer === "none") {
    return (
      <Modal
        open={props.open}
        onClose={props.close}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <div className={cssClasses.container}>
          <div className={cssClasses.header}>
            <p className={cssClasses.heading}>{props.title}</p>
            <CloseIcon
              sx={{ fontSize: "3rem", cursor: "pointer" }}
              onClick={props.close}
            />
          </div>
          <div className={cssClasses.contentWrapper}>
            <p className={cssClasses.subHeading}>{props.subTitle}</p>
            <div className={cssClasses.content}>{props.content}</div>
          </div>
        </div>
      </Modal>
    );
  } else {
    return (
      <Modal
        open={props.open}
        onClose={props.close}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <div className={cssClasses.container}>
          <div className={cssClasses.header}>
            <p className={cssClasses.heading}>{props.title}</p>
            <CloseIcon
              sx={{ fontSize: "3rem", cursor: "pointer" }}
              onClick={props.close}
            />
          </div>
          <div className={cssClasses.contentWrapper}>
            <p className={cssClasses.subHeading}>{props.subTitle}</p>
            <div className={cssClasses.content1}>{props.content}</div>
          </div>
          <div className={cssClasses.footer}>
            <div className={cssClasses.footerWrapper}>{props.footer}</div>
          </div>
        </div>
      </Modal>
    );
  }
}

export default AddModal;
